import { render, staticRenderFns } from "./SizeError.vue?vue&type=template&id=52ef84ed&"
import script from "./SizeError.vue?vue&type=script&lang=js&"
export * from "./SizeError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports